import React, { Fragment, useMemo } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { ErrorElement, GraphQLError } from '../../types/general';
import { AlertWrapper } from './SuccessAlert';

interface Props {
	renderAs?: 'alert' | 'text';
	title?: string;
	errors: ErrorElement;
	onClose?: () => void;
}

export function ErrorAlert(props: Props) {
	const { renderAs = 'alert', title, errors, onClose } = props;

	const errs = useMemo(() => {
		let errs = [] as GraphQLError[];
		if (typeof errors === 'string') {
			errs.push({ message: errors });
		} else {
			errs = (errors as any[]).map((error) => {
				if (typeof error === 'string') {
					return { message: error };
				}
				return error;
			});
		}
		return errs;
	}, [errors]);

	if (renderAs === 'text') {
		return (
			<Fragment>
				{errs &&
					errs.map((err, k) => (
						<div key={k}>
							<small className='text-danger form-text'>{err.message}</small>
						</div>
					))}
			</Fragment>
		);
	}

	return createPortal(
		<AlertWrapper>
			<ToastContainer className='p-3 position-fixed' style={{ zIndex: 2000 }} position='bottom-end'>
				<Toast onClose={onClose}>
					<Toast.Header className='Alert-header error'>
						<strong className='me-auto'>{title || 'Errore'}</strong>
					</Toast.Header>
					<Toast.Body className='Alert-body'>
						<table className='table table-sm table-borderless'>
							<tbody>
								{errs &&
									errs.map((err, k) => (
										<div key={k}>
											{err.code && (
												<tr>
													<td>
														<strong>Codice:</strong>
													</td>
													<td>{err.code}</td>
												</tr>
											)}
											{err.requestId && (
												<tr>
													<td>
														<strong>Request ID:</strong>
													</td>
													<td>{err.requestId}</td>
												</tr>
											)}
											{err.message && (
												<tr>
													<td colSpan={2}>{err.message}</td>
												</tr>
											)}
											<hr />
										</div>
									))}
							</tbody>
						</table>
					</Toast.Body>
				</Toast>
			</ToastContainer>
		</AlertWrapper>,
		document.body
	);
}
export default ErrorAlert;
